import React, { useContext, useRef, useState } from "react";
import CenterIcon from "../components/ui/CenterIcon";
import { description, printRelativeDate } from "../utils/ar";
import { baseURL } from "../config";
import { showPicture } from "../services/contentServices";
import LoadingIcon from "../components/ui/LoadingIcon";
import auth from "../services/authServices";
import http from "../services/httpServices";
import AuthContext from "../context/AuthContext";
import Button from "../components/ui/Button";

const CommunityCommentCard = ({ comment, posts, post, category, setPosts }) => {
    const imageSrcRef = useRef();
    const { adminToken } = useContext(AuthContext);
    const [isImageLoading, setIsImageLoading] = useState(true);

    const [isLoading, setIsLoading] = useState(false);

    const handlePostAction = async (action = "delete") => {
        const token = auth.getAdminToken();
        const config = auth.getAuthConfig(token);
        setIsLoading(true);

        try {
            if (action === "delete") {
                const { data } = await http.delete(
                    `/api/community/community_categories/${category.id}/posts/${post.id}/comments/${comment.id}`,
                    config
                );
                let newComments = post.community_comments.filter(
                    (value) => value.id !== comment.id
                );

                let newPosts = posts.map((value) => {
                    if (value.id !== post.id) {
                        return value;
                    } else {
                        return {
                            ...post,
                            community_comments: newComments,
                        };
                    }
                });

                setPosts([...newPosts]);
            }

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };
    return (
        <div className="bg-cyan-400 bg-opacity-20 border border-cyan-500 border-opacity-20 rounded-2xl pb-2 px-4">
            <div className="flex justify-between items-center">
                <div className="flex-center-both space-x-2 py-1 space-x-reverse">
                    <div className="sm:w-7 w-4 sm:h-7 h-4 rounded-full bg-cyan-100 dark:bg-cyan-700 flex-center-both smooth">
                        <CenterIcon
                            className="w-full h-full text-cyan-800 dark:text-cyan-400 smooth "
                            iconProperties={{ className: "h-3/4 w-3/4" }}
                            icon="uim:comment"
                        />
                    </div>
                    {/* <div className="">{post.user.full_name}</div> */}
                    <div className="clr-text-primary smooth">
                        <div className="font-w-bold font-smaller">{comment.user.full_name}</div>
                        <div className="clr-text-secondary smooth font-smaller  flex space-x-1 space-x-reverse">
                            <span>{printRelativeDate(comment.created_at)}</span>
                        </div>
                    </div>
                </div>

                {adminToken ? (
                    <div className="flex-center-both pl-5 font-smaller">
                        <Button
                            color="rose"
                            className="px-2 py-1"
                            onClick={() => handlePostAction("delete")}
                            isLoading={isLoading}
                        >
                            حذف
                        </Button>
                    </div>
                ) : (
                    ""
                )}
            </div>
            <div className="px-5">
                <div className="h-0.5 bg-cyan-700 bg-opacity-20 w-full rounded-md smooth"></div>
            </div>
            <div className="pt-1 sm:px-2 px-5 clr-text-primary smooth">
                {description(comment.description, true)}
            </div>
            {comment.image_source ? (
                <div className="px-2">
                    <div className="w-full rounded-md relative overflow-hidden text-center h-[150px] flex-center-both">
                        <img
                            src={`${baseURL}/${comment.image_source}`}
                            alt="course"
                            ref={imageSrcRef}
                            onLoad={() => {
                                setIsImageLoading(false);
                            }}
                            className={` ${
                                isImageLoading ? "hidden " : ""
                            } h-full max-w-full cursor-pointer rounded-md`}
                            onClick={() => showPicture(imageSrcRef.current.src, false)}
                        />
                        {isImageLoading ? (
                            <div className="h-full bg-slate-300 dark:bg-slate-50/10 flex-center-both font-h1 font-w-bold">
                                <div className="flex flex-row space-x-3 space-x-reverse">
                                    <LoadingIcon className={"font-big text-blue-500"} />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            ) : (
                ""
            )}
        </div>
    );
};

export default CommunityCommentCard;
